export default {
  title: "About",
  sections: {
    about_us_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">SEU Group</div> Swiss Engineers United',
            text2: 'The platform for engineers<br> in Switzerland',
            image: '/seu/latest-assets/seu_24.jpg',
          }
        },
      }
    },
    about_us_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'About us'
          }
        }
      }
    },
    about_us_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_29.jpg',
          }
        }
      }
    },
    about_us_text_section: {
      fields: {
        field_one: {
          value: {
            text: 'We think <br/> <div class="text-highlight">one step ahead </div>'
          }
        },
        field_two: {
          value: {
            text: 'SEU networks: Our group brings know-how, innovative ideas and the latest-assets technologies together under one roof.'
          }
        },
        field_three: {
          value: {
            text: ' We combine forces to serve the Swiss market according to the highest standards – and to lift our industry to a new level of performance. Together, we’re meeting the challenges of the engineering industry. Regionally, nationally and internationally.'
          }
        },
      }
    },
    about_us_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'About us'
          }
        }
      }
    },
    about_us_text2_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="text-highlight"> Corporate structure </br>  </div> Our foundation for<br> your success'
          }
        },
        field_two: {
          value: {
            text: 'We’ve designed the development of the SEU Group and the success of the individual partner companies to reinforce each other for the long term. As a partner company, you’ll benefit directly from the success of the entire group.'
          }
        },
        field_three: {
          value: {
            text: 'With the SEU business model, we offer successful engineering companies a partnership between equals that supports, strengthens and advances each individual brand. We also invite innovative independent professionals to develop their potential within our network before their firm runs out of steam due to a lack of skilled specialists or other challenges.'
          }
        },
      }
    },
    about_us_text3_section: {
      fields: {
        field_one: {
          value: {
            text: 'The <div class="text-highlight">SEU</div> company',
            text2: 'Visionary from the ground up'
          }
        },
        field_two: {
          value: {
            text: 'Swiss Engineers United AG is a holding company based in Pfäffikon SZ. We operate throughout Switzerland, as a consultant, service provider and producer. We have national and international production sites. The heart of SEU is currently the HMQ Group with 4 companies and over 125 employees.'
          }
        },
        field_three: {
          value: {
            text: 'The designers of Swiss Engineeres United are the right team for people with visions. We used to sit proudly on our self-made tree house platform and dream of big projects. Today, we design and develop living spaces, structures, and supply and transport networks for the whole of Switzerland - now as experienced engineers, strategists, business economists, and entrepreneurs.'
          }
        },
      }
    },
    about_us_slider_section: {
      fields: {
        sections: {
          value: {
            section_one: 'Shareholders',
            section_one_text: `Founders, private investors, those who have sold their businesses and employees from the partner companies take responsibility for SEU’s finances and are strategically and operationally involved in the further development of the group. After selling their companies, former owners have the opportunity to reinvest part of the sales proceeds in the SEU Group and contribute to the future development of the group as co-entrepreneurs.`,
            section_two: 'SEU Holding',
            section_two_text: `SEU is a central platform for engineering excellence. It enables synergies and economies of scale and an active exchange of ideas. Its business areas include <a href="/en/engineering" class="text-highlight">construction, geomatics and planning</a> and individual <a href="/en/services" class="text-highlight">support</a>.
            `,
            section_three: 'Partner companies',
            section_three_text: `SEU is built on a solid foundation composed of the individual partner companies. They retain their product portfolio, local and regional markets and their customer base.`,

          }
        },
        shareholders: {
          value: {
            boxes: [{
              text: `
              Founders and SEU Group employees`,
            }, {
              text: 'Private investors',
            }, {
              text: 'Sellers and partner company employees',
            }]
          }
        },
        partners: {
          value: {
            boxes: [{
              image: '/seu/hmq_gruppe.png'
            }, {
              text: 'Additional partner companies'
            }, {
              text: 'Additional partner companies'
            }, {
              text: 'Your company could be here'
            }]
          }
        },
      }
    },
    about_us_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'About us'
          }
        }
      }
    },
    about_us_team_section: {
      fields: {
        field_one: {
          value: {
            title: '<div class="text-highlight">board of<br> directors</div> ',
            description: 'Swiss Engineers United AG is a holding<br> company based in Pfaeffikon SZ',
            members: [
              {
                image: '/seu/members/seu_team_1.jpg',
                fullName: 'Franco Quinter',
                position: 'PRESIDENT',
                email: 'franco.quinter@seu.ch',
                phone: '+41 (0)79 682 47 47',
                website: 'quinter.ch',
                linkedin: 'https://linkedin.com/in/francoquinter',
                quote: '“We bring innovators together from all over Switzerland and draw in new professionals.“',
                boxes: [
                  {
                    experience: 'Graduate engineering degree (dipl. Ingenieur), ETH Zurich/Swiss Society of Engineers and Architects',
                  },
                  {
                    experience: 'Swiss-certified geomatics engineer',
                  },
                  {
                    experience: 'Founder and member of the HMQ Group board of directors',
                  },
                  {
                    experience: '25 years as managing director and project manager at HMQ Group',
                  },
                  {
                    experience: 'Multipreneur',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Business development experience',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_5.jpg',
                fullName: 'Patrick Kranz',
                position: 'VICE PRESIDENT',
                email: 'patrick.kranz@seu.ch',
                phone: '+41 (0)78 780 29 27',
                website: 'axalo.com',
                // linkedin: 'www.linkedin.com/in/dr-patrick-kranz-7154061b6',
                quote: '“Best practices are of great importance to us. We value each company’s individual recipe for success.“',
                boxes: [
                  {
                    experience: 'Doctorate in management (Dr. oec.) from the University of St. Gallen (HSG)',
                  },
                  {
                    experience: 'Multipreneur, including in the engineering and surveying sector',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Experience in management consulting (McKinsey & Company) and private equity (Fabrel Lotos)',
                  },
                  {
                    experience: 'Chartered Financial Analyst',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_4.jpg',
                fullName: 'Christian Vetsch',
                position: 'BOARD MEMBER',
                email: 'christian.vetsch@seu.ch',
                phone: '+41 (0)79 361 13 45',
                linkedin: 'https://linkedin.com/in/christianvetsch',
                quote: '“Finding a solution to ownership succession means solving an existential challenge. We ensure the optimal framework conditions.“',
                boxes: [
                  {
                    experience: 'Survey engineer, University of Applied Sciences and Arts Northwestern Switzerland (FHNW)',
                  },
                  {
                    experience: 'Executive Master of Business Administration, University of Applied Sciences of the Grisons (FHGR)',
                  },
                  {
                    experience: 'Certificate of Advanced Studies in corporate finance and mergers & acquisitions, Zurich University of Applied Sciences (ZHAW)',
                  },
                  {
                    experience: 'Founder and member of the HMQ Group board of directors',
                  },
                  {
                    experience: '28 years as managing director and project manager at HMQ Group',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_2.jpg',
                fullName: 'Rogier Engelsma',
                position: 'BOARD MEMBER <br/>HEAD OF FINANCING',
                email: 'rogier.engelsma@seu.ch',
                phone: '+41 (0)76 335 99 81',
                linkedin: 'https://linkedin.com/in/rogierengelsma',
                quote: '“We offer an answer to the challenges currently facing our field: Cooperation as partners with a forward-looking strategy instead of predatory competition.”',
                boxes: [
                  {
                    experience: 'Degree in management (lic. oec.) from the University of St. Gallen (HSG)',
                  },
                  {
                    experience: '17 years of experience in direct investment/private equity (Rivean Capital, Verium, Trilenium)',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Management consulting experience (Arthur D. Little)',
                  },

                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_6.jpg',
                fullName: 'Marco Quinter',
                position: 'BOARD MEMBER<br/>HEAD OF MARKETING<br/>AND COMMUNICATION',
                email: 'marco.quinter@seu.ch',
                phone: '+41 (0)79 402 91 11',
                linkedin: 'https://linkedin.com/in/marcoquinter',
                quote: '“We combine all types of expertise needed for sound and sustainable group growth.“',
                boxes: [
                  {
                    experience: 'Degree in economics (lic. oec. publ.), University of Zurich',
                  },
                  {
                    experience: '20 years in management at UPC Switzerland',
                  },
                  {
                    experience: 'Multipreneur in the areas of IT, blockchain and telecommunications',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },

                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
            ]
          }
        }
      }
    },
    about_us_divider4_section: {
      fields: {
        field_one: {
          value: {
            divider: 'About us'
          }
        }
      }
    },
    about_us_members_section: {
      fields: {
        field_one: {
          value: {
            title: '<div class="text-highlight">executive<br> board</div>',
            description: 'We design and develop living spaces, buildings and supply and transport networks for all of Switzerland – as experienced engineers, planners, and entrepreneurs',
            members: [
              {
                image: '/seu/members/seu_team_4.jpg',
                fullName: 'Christian Vetsch',
                position: 'CEO',
                email: 'christian.vetsch@seu.ch',
                phone: '+41 (0)79 361 13 45',
                linkedin: 'https://linkedin.com/in/christianvetsch',
                quote: '“Finding a solution to ownership succession means solving an existential challenge. We ensure the optimal framework conditions.”',
                boxes: [
                  {
                    experience: 'Survey engineer, University of Applied Sciences and Arts Northwestern Switzerland (FHNW)',
                  },
                  {
                    experience: 'Executive Master of Business Administration, University of Applied Sciences of the Grisons (FHGR)',
                  },
                  {
                    experience: 'Certificate of Advanced Studies in corporate finance and mergers & acquisitions, Zurich University of Applied Sciences (ZHAW)',
                  },
                  {
                    experience: 'Founder and member of the HMQ Group board of directors',
                  },
                  {
                    experience: '28 years as managing director and project manager at HMQ Group',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_1.jpg',
                fullName: 'Franco Quinter',
                position: 'STRATEGY & ORGANIZATION',
                email: 'franco.quinter@seu.ch',
                phone: '+41 (0)79 682 47 47',
                website: 'quinter.ch',
                linkedin: 'https://linkedin.com/in/francoquinter',
                quote: '“We bring innovators together from all over Switzerland and draw in new professionals.“',
                boxes: [
                  {
                    experience: 'Graduate engineering degree (dipl. Ingenieur), ETH Zurich/Swiss Society of Engineers and Architects',
                  },
                  {
                    experience: 'Swiss-certified geomatics engineer',
                  },
                  {
                    experience: 'Founder and member of the HMQ Group board of directors',
                  },
                  {
                    experience: '25 years as managing director and project manager at HMQ Group',
                  },
                  {
                    experience: 'Multipreneur',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Business development experience',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_3.jpg',
                fullName: 'Marek Franke',
                position: 'BUSINESS DEVELOPMENT',
                email: 'marek.franke@seu.ch',
                phone: '+41 (0)79 458 20 32',
                linkedin: 'www.linkedin.com/in/marekfranke/',
                quote:'“Our group is more than the sum of its successful partner companies. <br> 1 + 1 > 2: This is SEU’s formula for success!“',
                boxes: [
                  {
                    experience: 'Degree in business administration (lic. rer. pol.), University of Fribourg',
                  },
                  {
                    experience: '20 years of experience in corporate succession, company purchase and sale, M&A, post-merger integration',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Founder of multiple start-ups',
                  },
                  {
                    experience: 'Investor in impact investment projects',
                  },
                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_2.jpg',
                fullName: 'Rogier Engelsma',
                position: 'FINANCING',
                email: 'rogier.engelsma@seu.ch',
                phone: '+41 (0)76 335 99 81',
                linkedin: 'https://linkedin.com/in/rogierengelsma',
                quote: '“We offer an answer to the challenges currently facing our field: Cooperation as partners with a forward-looking strategy instead of predatory competition.”',
                boxes: [
                  {
                    experience: 'Degree in management (lic. oec.) from the University of St. Gallen (HSG)',
                  },
                  {
                    experience: '17 years of experience in direct investment/private equity (Rivean Capital, Verium, Trilenium)',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },
                  {
                    experience: 'Management consulting experience (Arthur D. Little)',
                  },

                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
              {
                image: '/seu/members/seu_team_6.jpg',
                fullName: 'Marco Quinter',
                position: 'MARKETING & COMMUNICATION',
                email: 'marco.quinter@seu.ch',
                phone: '+41 (0)79 402 91 11',
                linkedin: 'https://linkedin.com/in/marcoquinter',
                quote: '“We combine all types of expertise needed for sound and sustainable group growth.“',
                boxes: [
                  {
                    experience: 'Degree in economics (lic. oec. publ.), University of Zurich',
                  },
                  {
                    experience: '20 years in management at UPC Switzerland',
                  },
                  {
                    experience: 'Multipreneur in the areas of IT, blockchain and telecommunications',
                  },
                  {
                    experience: 'Positions on various boards of directors',
                  },

                ],
                buttonLabel: 'LEARN MORE',
                buttonLabelLess: 'CLOSE'
              },
            ]
          }
        }
      }
    }
  }
}
